<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    console.log("250922-fhyx修改页脚备案号");
  },
};
</script>

<style>
#app {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue